/**
 * @module JQM
 * @param  {Object} $ jQuery-Objekt
 * @return {Null}
 */

function getHashFilter() {
  // get filter=filterName
  var matches = location.hash.match( /filter=([^&]+)/i );
  var hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent( hashFilter );
}

(function($) {
    "use strict";

    /**
     * Global bereit gestelltes Objekt, das durch Module erweitert werden
     * kann und welches die Grundfunktionalität der Anwendung bereit stellt.
     *
     * @class  JQM
     * @constructor
     */
    var JQM = (function() {
        /**
         * Initialisierung der Anwendung.
         *
         * @method init
         * @return {Null}
         */
        function init() {
            AOS.init();

            // Active-State auf mobilen Devices nutzen
            if("ontouchstart" in document.documentElement) {
                document.addEventListener("touchstart", function() {}, true);

                // only for mobile devices to prevent showing only a white screen when reloading the page
                $(window).on("load", function() {
                    AOS.refresh();
                });
            }

            $('.isotope').isotope({
              // options
              itemSelector: '.section-post--item',
              layoutMode: 'fitRows'
            });   

            $('.isotope-button-group').on( 'click', 'button', function() {
                var filterValue = $(this).attr('data-filter');
                if (filterValue != '*') {
                    $('.isotope').isotope({ filter: '[data-type="' + filterValue + '"]' });
                    location.hash = 'filter=' + encodeURIComponent(filterValue);
                } else {
                    $('.isotope').isotope({ filter: '*' });
                    location.hash = 'filter=' + encodeURIComponent('*');
                }
            });    

            // inital filtering if URL hash is present
            window.setTimeout(function () {                
                var hashFilter = getHashFilter();
                if ( hashFilter ) {
                    $('.isotope').isotope({ filter: '[data-type="' + hashFilter + '"]' });
                }}, 500
            );

            // Initialisierung von JQM Modulen
            initModules();
        }

        /**
         * Es werden alle Module initialisiert, die über die Funktion `init`
         * verfügen. Um eine Initialisierung zu verhindern, wird bei den entsprechenden
         * Modulen für die Init-Funktion `_init` verwendet.
         *
         * @private
         * @method initModules
         * @return {Null}
         */
        function initModules() {
            var module;
            for(module in JQM) {
                if(
                    JQM.hasOwnProperty(module) &&
                    typeof JQM[module].init === "function"
                ) {
                    JQM[module].init();
                }
            }
        }

        return {
            init: init
        };
    })();

    $(document).ready(function() {
        JQM.init();
    });

    // Im globalen Kontext bereitstellen
    window.JQM = JQM;
})(jQuery);
